// extracted by mini-css-extract-plugin
module.exports = {"first":"HeaderTitle_first__dggPz","second":"HeaderTitle_second__18TTS","third":"HeaderTitle_third__1KAz4","four":"HeaderTitle_four__2So5G"};